<ng-container>
  <!-- Default -->
  <ng-container *ngIf="showInDefault || isUnits">
    <!-- NOT Units -->
    <span *ngIf="!isUnits"
      [class.make-bold]="amountIsBold">
      {{ amount | gcMoney: defaultCurrency: true }}
    </span>

    <!-- IF Units -->
    <ng-container *ngIf="isUnits">
      <!-- Number of Units String -->
      <span *ngIf="!showItemPopover || !inKindItems?.length"
        [class.make-bold]="amountIsBold">
        <yc-i18n
          key="GLOBAL:textNumberUnits"
          [context]="{
            number: inKindItems ?
              ((inKindItems | gcInKindNumberOfUnits) | number) :
              inKindItemTotalCount
          }"
          defaultValue="__number__ units">
        </yc-i18n>
        <span *ngIf="amount || amount === 0"
          [class.d-block]="unitsOnNewLine">
          {{ amount | gcMoney: defaultCurrency: true }}
        </span>
      </span>
      <div *ngIf="showItemPopover &&
        (inKindItems?.length || inKindItemTotalCount > 0)">
        <gc-in-kind-items-popover
          [inKindItems]="inKindItems"
          [amountIsBold]="amountIsBold"
          [applicationId]="applicationId"
          [amount]="amount"
          [inKindItemTotalCount]="inKindItemTotalCount"
          [popoverPlacement]="popoverPlacement"
          [unitsOnNewLine]="unitsOnNewLine"
          [alignRight]="alignRight">
        </gc-in-kind-items-popover>
      </div>
    </ng-container>
  </ng-container>

  <!-- In Requested -->
  <span *ngIf="!showInDefault && !isUnits"
    class="no-wrap"
    [class.make-bold]="amountIsBold">
    {{ equivalent | gcMoney: currencyRequested: true }}
  </span>
</ng-container>
